module.exports = "float PI_4 = 0.7853981634;"